import { Component, OnInit } from '@angular/core';
import {NzModalRef, NzModalService} from "ng-zorro-antd/modal";
import {ApiService} from "../../../../services/api.service";
import {BehaviorSubject} from "rxjs";
import {Router} from "@angular/router";

@Component({
  selector: 'app-configure-email-modal',
  templateUrl: './configure-email-modal.component.html',
  styleUrls: ['./configure-email-modal.component.scss']
})
export class ConfigureEmailModalComponent implements OnInit {

  $loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  $submitting: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  $emailConfig: BehaviorSubject<any> = new BehaviorSubject<any>({});

  constructor(
    public modal: NzModalRef,
    public modalService: NzModalService,
    public api: ApiService,
    public router: Router
  ) {}

  ngOnInit(): void {
    this.api.apiGet('/settings/user/email').then((EmailConfig)=>{
      this.$emailConfig.next(EmailConfig);
      this.$loading.next(false);
    });
  }

  destroyModal(): void {
    this.modal.destroy();
  }

  confirm(){


  }

}
